import styled from "styled-components";
import { theme } from "@tm/utility/global";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Container = styled.div<{ isFocused?: boolean }>`
  background: ${(p) => (p.isFocused ? theme.lightBlueBg : "#f6f6f6")};
  border-radius: 8px;
  border: 1px solid ${(p) => (p.isFocused ? theme.blueText : "#d8d8d8")};
  padding: 5px 12px 6px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Label = styled.div<{ isFocused?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  color: ${(p) => (p.isFocused ? theme.blueText : "#757575")};
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CountValue = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
`;

export const HelpText = styled.div`
  padding-left: 12px;
  font-size: 12px;
  font-weight: 400;
  color: #757575;
  line-height: 14px;
`;

export const InlineInput = styled.input`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  width: 100%;
  font-family: inherit;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;
